<script setup lang="ts">
const { gallery, id } = defineProps<{ gallery?: string[], id?: string }>()

const isOpen = ref(false)
const currentIndex = ref(0)

const images = computed(() => (gallery ?? []).filter(Boolean))

const currentImage = computed(() => images.value[currentIndex.value])

function openGallery(index: number) {
  currentIndex.value = index
  isOpen.value = true
}

function previousImage() {
  if (!images.value.length) return
  currentIndex.value = (currentIndex.value - 1 + images.value.length) % images.value.length
}

function nextImage() {
  if (!images.value.length) return
  currentIndex.value = (currentIndex.value + 1) % images.value.length
}

watch(images, () => {
  if (currentIndex.value >= images.value.length) {
    currentIndex.value = 0
  }
})
</script>

<template>
  <div v-if="images.length && id">
    <UAvatarGroup>
      <button
        v-for="(image, index) in images"
        :key="image"
        type="button"
        class="rounded-full focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-500"
        @click="openGallery(index)"
      >
        <UAvatar
          :src="getImagePath({ collectionId: REVIEW_COLLECTION_ID, id, src: image })"
          :alt="image"
          size="xl"
          class="cursor-pointer"
        />
      </button>
    </UAvatarGroup>

    <UModal
      v-model="isOpen"
      :ui="{ rounded: 'rounded-2xl overflow-clip', width: 'w-full sm:max-w-4xl' }"
    >
      <div class="bg-blue text-white p-4 md:p-6">
        <div class="flex items-center justify-between gap-3 pb-4">
          <p class="text-sm uppercase tracking-[0.2em] text-slate-300">
            Gallery {{ currentIndex + 1 }} / {{ images.length }}
          </p>
          <UButton
            color="white"
            icon="heroicons:x-mark-16-solid"
            aria-label="Close gallery"
            @click="isOpen = false"
          />
        </div>

        <div class="flex items-center gap-3">
          <UButton
            color="gray"
            variant="soft"
            icon="heroicons:chevron-left-16-solid"
            aria-label="Previous image"
            @click="previousImage"
          />

          <div class="flex-1 flex justify-center">
            <ImageFull
              :id="id"
              :key="id"
              :src="currentImage"
              :collection-id="REVIEW_COLLECTION_ID"
              class="max-h-[75vh] w-full object-contain rounded-xl"
            />
          </div>

          <UButton
            color="gray"
            variant="soft"
            icon="heroicons:chevron-right-16-solid"
            aria-label="Next image"
            @click="nextImage"
          />
        </div>
      </div>
    </UModal>
  </div>
</template>
